const ultimateLightboxExtension = (selector) => {
    if (typeof ewd_ulb_php_data == "undefined")
    {
        ewd_ulb_php_data = [];
    }
    var lightbox = new UltimateLightbox(ewd_ulb_php_data);

    jQuery('body').on('click', selector, function(event) {
        if ( typeof jQuery(event.currentTarget).data('slideIndex') !== 'undefined' )
        {
            lightbox.currentSlide = jQuery(event.currentTarget).data('slideIndex');
        }
        else
        {
            lightbox.setCurrentSlide(event.currentTarget);
        }
        lightbox.toggle();
        event.preventDefault();
    })

    if (jQuery(selector).length)
    {
        EWD_ULB_Add_Lightbox_HTML(lightbox);
        jQuery('.ewd-ulb-slide-container').on('click.background', function(event)
        {
            if ( event.target.nodeName !== undefined && ( event.target.nodeName == "IMG" || event.target.nodeName == "iframe" || ( ewd_ulb_php_data.hasOwnProperty( 'background_close' ) && ! ewd_ulb_php_data.background_close ) ) )
            {return;}
            //alert(event.toElement.className);

            lightbox.toggle();
        });

        jQuery('.ewd-ulb-slide-control-next').on('click.next', function() {
            lightbox.noZoom();
            lightbox.stopAutoplay();
            lightbox.nextSlide();
        });
        jQuery('.ewd-ulb-slide-control-previous').on('click.prev', function() {
            lightbox.noZoom();
            lightbox.stopAutoplay();
            lightbox.previousSlide();
        });

        //Wrong Interpretation -  must be modified so the image move like a carousel
        jQuery('.ewd-thumbnail-scroll-button-left').on('click.prev', function() {
            lightbox.noZoom();
            lightbox.stopAutoplay();
        });
        jQuery('.ewd-thumbnail-scroll-button-right').on('click.next', function() {
            lightbox.noZoom();
            lightbox.stopAutoplay();
        });


        jQuery('.ewd-ulb-slide-thumbnail').on('click.thumbnail', function() {

            var slideIndex = jQuery(this).data("slideindex");
            lightbox.noZoom();
            lightbox.stopAutoplay();
            lightbox.goToSlide(slideIndex);

        });

        jQuery( '.ewd-thumbnail-toggle' ).on( 'click.thumbnail_toggle', function() {

            lightbox.toggleThumbnailBar();
        });

        jQuery(window).on('resize', function() {
            lightbox.resizeOverlay()
        });

        jQuery('.ewd-ulb-exit').on('click.exit', function() {
            lightbox.toggle();
        });
        jQuery('.ewd-ulb-autoplay').on('click.autoplay', function() {
            lightbox.toggleAutoplay();
        });
        jQuery('.ewd-ulb-zoom').on('click.zoom', function() {
            lightbox.toggleZoom();
        });
        jQuery('.ewd-ulb-zoom_out').on('click.zoom_out', function() {
            lightbox.ZoomOut();
        });
        jQuery('.ewd-ulb-fullsize').on('click.fullsize', function() {
            lightbox.toggleFullSize();
        });
        jQuery('.ewd-ulb-fullscreen').on('click.zoom_out', function() {
            lightbox.fullscreen();
        });
        jQuery('.ewd-ulb-download').wrap('<a class="ewd-ulb-download-link" href="empty.png" download></a>');

        if (lightbox.settings.keyboard_controls) {
            jQuery(document).on('keyup', function(e) {
                if (e.which == 27) {lightbox.closeLightbox();}
                if (e.which == 37) {
                    lightbox.noZoom();
                    lightbox.stopAutoplay();
                    lightbox.previousSlide();
                }
                if (e.which == 39) {
                    lightbox.noZoom();
                    lightbox.stopAutoplay();
                    lightbox.nextSlide();
                }
            });
        }

        //LISTENERS

        jQuery(".ewd-ulb-slide-area").on("touchstart", function(event) {
            slider.longTouch = false;
            setTimeout(function() { // Since the root of setTimout is window we can’t reference this. That’s why this variable says window.slider in front of it.
                window.slider.longTouch = true;
            }, 250);

            // Get the original touch position.
            slider.touchstartx =  event.originalEvent.touches[0].pageX;

            // if(jQuery('.animate').length>0)
            // {
            //    	jQuery('.animate').removeClass('animate');
            // }
        });

        jQuery(".ewd-ulb-slide-area").on("touchmove", function(event) {
            slider.touchmovex =  event.originalEvent.touches[0].pageX;
            //console.log("Index: " + slider.index);

            // Calculate distance to translate holder.3
            slider.slideWidth = jQuery(".ewd-ulb-slide-container").width();
            slider.movex = (slider.touchstartx - slider.touchmovex);
            //console.log("Slider Move:" + slider.movex);

            // Defines the speed the images should move at.
            var panx = 100-slider.movex/6;
            // If it is a curtain slider just return
            if(jQuery('.ewd-ulb-active-slide.ewd-ulb-image-displaying').find('.twentytwenty-container').length > 0)
            {
                return;
            }
            if(slider.movex > 0)//swiping forward - this will move the image
            {
                if (slider.movex < 600) { // Makes the holder stop moving when there is no more content.
                    jQuery(".ewd-ulb-slide-container").css('transform','translate3d(-' + slider.movex + 'px,0,0)');
                }
                if (panx < 100) { // Corrects an edge-case problem where the background image moves without the container moving.
                    jQuery(".ewd-ulb-image-displaying img").css('transform','translate3d(-' + panx + 'px,0,0)');
                }
            }
            else if (slider.movex < 0)//swiping backward - this will move the image
            {

                if (slider.movex < 600) { // Makes the holder stop moving when there is no more content.
                    jQuery(".ewd-ulb-slide-container").css('transform','translate3d(' + Math.abs(slider.movex)+ 'px,0,0)');
                }
                if (panx < 100) { // Corrects an edge-case problem where the background image moves without the container moving.
                    jQuery(".ewd-ulb-image-displaying img").css('transform','translate3d(' + Math.abs(panx) + 'px,0,0)');
                }

            }

        });

        jQuery(".ewd-ulb-slide-area").on("touchend", function(event) {
            // Calculate the distance swiped.
            var absMove = Math.abs(slider.movex);

            // Calculate the index. All other calculations are based on the index.
            if (absMove > slider.slideWidth/2 || slider.longTouch === false)
            {
                //change image
                if(slider.movex < 0)
                {
                    lightbox.previousSlide(); // leftswipe - change to previous image
                }
                else if( slider.movex > 0)
                {
                    lightbox.nextSlide(); // rightswipe - change to next image
                }

            }
            //Because the boxes have moved from original location,we need to bring them back
            jQuery(".ewd-ulb-slide-container").css('transform','none');
            jQuery(".ewd-ulb-image-displaying img").css('transform','none');


        });
    }
}

export default  ultimateLightboxExtension